import React, { useEffect } from 'react'
import Modal from '../../../components/Modal/Modal'
import { FieldValues, FormProvider, useForm } from 'react-hook-form'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { Button, TabMenu } from '@demandlocal/components'
import { useNavigate } from 'react-router'
import DealershipInfo from './Routes/DealershipInfo'
// import DealershipIntegrations from './Routes/DealershipIntegrations'
import states from '../../../lib/utils/states'
import toast from 'react-hot-toast'
import countries from '../../../lib/utils/countries'
import { queryClient } from '../../../api/queryClient'
import { useGetDealershipById } from '../../../api/agencies/dealership/useGetDealership'
import { useEditDealership } from '../../../api/agencies/dealership/useEditDealership'
import DealershipIntegrations from './Routes/DealershipIntegrations'
import { VENDOR } from '../../../lib/utils/vendors'

export const IndustryOptions = [
  {
    label: 'Automotive',
    value: 'automotive',
  },
  {
    label: 'Retail',
    value: 'retail',
  },
]

export default function EditDealership(): JSX.Element {
  const { agency_id, dealership_id } = useParams()
  const { data, isLoading } = useGetDealershipById(dealership_id)
  const formContext = useForm({
    mode: 'onSubmit',
  })

  console.log(data)

  const { mutateAsync } = useEditDealership()
  const navigate = useNavigate()

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting, isDirty },
  } = formContext

  useEffect(() => {
    reset({
      ...data,
      industry: IndustryOptions.find((i) => i.value === data?.industry),
      state: states.filter((state) => data?.state?.includes(state.value)),
      country: countries.find((country) => data?.country?.includes(country.value)) || {
        label: 'USA',
        value: 'USA',
      },
      ga4_accounts: data?.vendorAccounts
        ?.filter((v) => v._id === VENDOR.GoogleAnalytics)
        ?.flatMap((v) => v.accounts),
    })
  }, [data, reset])

  const onSubmit = async (values: Partial<FieldValues>): Promise<void> => {
    const toastId = toast.loading('Saving...')
    try {
      await mutateAsync({
        id: dealership_id,
        data: {
          dealership: values?.dealership,
          address: values?.address,
          city: values?.city,
          state: values?.state?.value,
          country: values?.country?.value,
          zip: values?.zip,
          email: values?.email,
          phone: values?.phone,
          url: values?.url,
          industry: values?.industry?.value,
          ga4_accounts: values?.ga4_accounts,
        },
      })

      await queryClient.invalidateQueries([
        'agencies',
        'profile',
        'clients',
        'active',
        {
          pageSize: 10,
          pageIndex: 1,
          queryParams: {
            agency_id,
          },
        },
      ])
      toast.success('Saved!', { id: toastId })
      navigate('../')
    } catch (err) {
      toast.error('Unable to save dealership at this time', {
        id: toastId,
        duration: 5000,
      })
    }
  }
  return (
    <Modal modalRoute={true} isOpen={true} key={'AgencyEditDealership'}>
      <FormProvider {...formContext}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={'flex flex-1 flex-col h-screen'}>
          <div
            className={
              'flex flex-1 flex-col px-10 max-w-[1920px] mx-auto w-full h-screen'
            }>
            <div className={'text-3xl font-bold mt-12'}>Edit {data?.dealership}</div>
            <div className={'pt-12 pb-2'}>
              <TabMenu
                options={[
                  { name: 'Details', to: 'details' },
                  {
                    name: 'Integrations',
                    to: 'integrations',
                  },
                ]}
              />
            </div>
            <div className={'font-Spartan overflow-scroll h-full'}>
              <Routes>
                <Route path={'details'} element={<DealershipInfo />} />
                <Route path={'integrations'} element={<DealershipIntegrations />} />
                <Route path={'*'} element={<Navigate to={'details'} />} />
              </Routes>
            </div>
            <div className={'flex justify-between py-5 border-t-2'}>
              <Button
                disabled={isSubmitting}
                variant={'secondary'}
                animate={false}
                type={'button'}
                onClick={() => {
                  if (isDirty) {
                    confirm(
                      'Are you sure you want to leave this page? All unsaved changes will be lost.',
                    )
                    {
                      navigate('../')
                    }
                  } else {
                    navigate('../')
                  }
                }}>
                Cancel
              </Button>
              <Button animate={false} disabled={isSubmitting} variant={'primary'}>
                Save
              </Button>
            </div>
          </div>
        </form>
      </FormProvider>
    </Modal>
  )
}
